import React from 'react';
import { Button } from '@/components/ui/button';
import { Bell, ExternalLink, AlertTriangle } from 'lucide-react';

export const NotificationSection = ({ 
  pushSupported, 
  pushSubscribed, 
  pushLoading, 
  pushPermission,
  onTogglePush 
}) => {
  return (
    <div className="bg-white/60 backdrop-blur-md border border-[#EAE4DC] shadow-lg rounded-2xl p-8">
      <div className="flex items-center space-x-3 mb-6">
        <Bell className="w-6 h-6 text-stone-600" strokeWidth={1.5} />
        <h2
          className="text-2xl font-medium"
          style={{ fontFamily: 'Playfair Display, serif' }}
        >
          Notifications
        </h2>
      </div>
      
      {pushSupported ? (
        <div className="space-y-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="font-medium text-stone-800">Push Notifications</p>
              <p className="text-sm text-stone-500">
                Receive gentle reminders for your daily reflection
              </p>
            </div>
            <Button
              onClick={onTogglePush}
              disabled={pushLoading}
              variant={pushSubscribed ? "outline" : "default"}
              className={`rounded-full px-6 ${pushSubscribed ? '' : 'text-[#1A1A2E]'}`}
              style={pushSubscribed ? {} : { backgroundColor: '#C9A84C' }}
              data-testid="toggle-push-button"
            >
              {pushLoading ? '...' : pushSubscribed ? 'Disable' : 'Enable'}
            </Button>
          </div>
          
          {pushPermission === 'denied' && (
            <div className="p-3 rounded-lg bg-amber-50 border border-amber-200">
              <div className="flex items-center gap-2 text-amber-700 text-sm">
                <AlertTriangle className="w-4 h-4" />
                <span>Notifications are blocked. Please enable in browser settings.</span>
              </div>
            </div>
          )}
        </div>
      ) : (
        <p className="text-stone-500 text-sm">
          Push notifications are not supported in this browser.
        </p>
      )}
    </div>
  );
};
